import { RatingService } from '@games/infra';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CreateAppRatingDto } from '@core-http';
import { RateAppCommandPayload } from './rate-app.command-payload';

export class RateAppCommandHandler {
  private readonly ratingService: RatingService = inject(RatingService);

  rateApp(payload: RateAppCommandPayload): Observable<void> {
    const body: CreateAppRatingDto = this.mapToDto(payload);

    return this.ratingService.rateApplication(body);
  }

  private mapToDto(payload: RateAppCommandPayload): CreateAppRatingDto {
    return {
      gameId: payload.gameId,
      appRate: payload.appRate,
      hostRate: payload.hostRate,
      comment: payload.comment
    };
  }
}
